import { Component, Input, OnInit } from '@angular/core';
import { IContractData, IItems } from '../../../interfaces/IJob';
import { ISpecialBenefitsContactsItem } from '../../../interfaces/ISpecialBenefitsItem';
import { CE_CUSTOMER_PHONE, CE_PLAN, PM_REIMBURSEMENT_ITEM_CODE, SPECIAL_BENEFITS_CONTACT_NUMBERS, TXU_CUSTOMER_PHONE, TXUCE_PLAN } from '../../../utils/constants';
import { DataService } from '../../../services/data/data.service';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { Subject, takeUntil } from 'rxjs';
import { CE_URL, CONSUMER_ELECTRONICS, CONSUMER_ELECTRONICS_TXU, HOME_ELCTRNCS, HOME_ELECTRONICS, HOMEE } from './special-benefits.constants';
import { SPECIAL_BENEFITS_BUTTON_NAME } from '../../../services/ga4/ga4.constant';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-special-benefits',
  templateUrl: './special-benefits.component.html',
  styleUrl: './special-benefits.component.scss'
})
export class SpecialBenefitsComponent implements OnInit {
  @Input() pageLocation!: string;
  specialBenefitsContacts: ISpecialBenefitsContactsItem[] = [];
  cleaner$ = new Subject<void>();
  specialBenefitsButtonName: string = SPECIAL_BENEFITS_BUTTON_NAME;
  trackByIndex = trackByIndex;
  constructor(private data: DataService, private utilService: UtilitiesService) {}

  ngOnInit(): void {
    this.data.contractData$.pipe(takeUntil(this.cleaner$)).subscribe({
      next: (contract) => contract && this.buildSpecialBenefitsContacts(contract)
    });
  }

  buildSpecialBenefitsContacts(contract: IContractData): void {
    if (!contract?.productBaseCoverage?.baseItems) return;

    this.specialBenefitsContacts = contract.productBaseCoverage.baseItems
      .filter((item: IItems) => SPECIAL_BENEFITS_CONTACT_NUMBERS[item.itemCode])
      .map((item: IItems) => {
        const numberInDescription = item.description.match(/\d+/);
        const dollarMatch = item.description.match(/\$\d+/);
        const itemDescription = numberInDescription && !dollarMatch
          ? item.description.replace(numberInDescription[0], `$${numberInDescription[0]}`)
          : item.description;

        return {
          itemCode: item.itemCode,
          itemDescription,
          phoneNumber: SPECIAL_BENEFITS_CONTACT_NUMBERS[item.itemCode].phoneNumber,
          groupNumber: SPECIAL_BENEFITS_CONTACT_NUMBERS[item.itemCode].groupNumber,
          isPMReimbursementItem: item.itemCode === PM_REIMBURSEMENT_ITEM_CODE
        };
      });

    this.addSpecialCases(contract);
  }

  addSpecialCases(contract: IContractData): void {
    const productName = contract.productBaseCoverage?.productInfo?.name || '';
    const coverageGroup = contract.baseContract?.coverageGroup || '';

    if (productName.includes(HOME_ELECTRONICS) || productName.includes(HOME_ELCTRNCS)) {
      if (coverageGroup === CE_PLAN) {
        this.specialBenefitsContacts.push({
          itemCode: HOMEE,
          itemDescription: CONSUMER_ELECTRONICS,
          phoneNumber: CE_CUSTOMER_PHONE,
          groupNumber: null,
          url: CE_URL,
          isPMReimbursementItem: false
        });
      } else if (coverageGroup === TXUCE_PLAN) {
        this.specialBenefitsContacts.push({
          itemCode: HOMEE,
          itemDescription: CONSUMER_ELECTRONICS_TXU,
          phoneNumber: TXU_CUSTOMER_PHONE,
          groupNumber: null,
          url: CE_URL,
          isPMReimbursementItem: false
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
